<template>
  <div class="course-structure">
    <header>
      <div class="title">Содержание курса</div>
      <p>Созадайте содержание курса используя тесты и материалы</p>
    </header>


    <div class="structure">
      <div
        v-for="(block, index) of structure"
        :key="index"
        class="block"
      >
        <div class="info">
          <div class="title">{{ block.title }}</div>
          <div class="type" :class="[block.type]">
            {{ block.type === 'material' ? 'Материал' : 'Тест' }}
          </div>
        </div>

        <div class="actions">
          <div class="delete" @click="deleteItemStructure(index)">Удалить</div>
          <div class="change" @click="changeItemStructure(block)">Изменить</div>
        </div>
      </div>

      <div v-if="!structure.length" class="block empty-block">
        Нажмите на <span>+</span> чтобы добавить
        <br />
        тест или материал
      </div>

      <div class="add-block" @click="openChooseEntityModal">
        <UIcon name="plus-circle" />
      </div>

      <div class="line-vertical"></div>
    </div>

    <UModal v-model="isModalChoseEntity" close :width="entityModalWidth" :type="entityModalType">
      <ChooseEntityWrapper
        v-if="isModalChoseEntity"
        @addEntity="addEntity($event)"
        @modeChange="entityModalMode = $event"
      />
    </UModal>
  </div>
</template>

<script>
import UModal from '@/components/redesign/ui/UModal'
import ChooseEntityWrapper from '@/components/redesign/base/choose-entity/ChooseEntityWrapper'

export default {
  name: 'CourseStructure',
  components: { ChooseEntityWrapper, UModal },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isModalChoseEntity: false,
      entityModalMode: 'choose',
    }
  },
  computed: {
    structure: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    entityModalWidth() {
      return this.entityModalMode === 'create' ? '1180px' : '600px';
    },
    entityModalType() {
      return this.entityModalMode === 'create' ? 'course-entity-create-modal' : '';
    }
  },
  methods: {
    openChooseEntityModal() {
      this.entityModalMode = 'choose';
      this.isModalChoseEntity = true;
    },
    addEntity(entity) {
      this.structure = [...this.structure, entity]
      this.entityModalMode = 'choose'
      this.isModalChoseEntity = false
    },
    deleteItemStructure(index) {
      const structure = [...this.structure]
      structure.splice(index, 1)
      this.structure = structure
    },
    changeItemStructure(block) {
      let path = `/article/${block.id}`

      if (block.type === 'test') path = `/test/${block.id}`
      window.open(path, '_blank');
    }
  }
}
</script>

<style lang="scss">
.course-structure {
  width: 100%;
  padding: 30px;
  background: #fff;
  border-radius: 10px;

  header {
    margin-bottom: 40px;

    & > .title {
      font-weight: 600;
      font-size: 22px;
      line-height: 18px;
    }

    p {
      margin-top: 12px;
      margin-bottom: 40px;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: #717171;
    }
  }

  .structure {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .block {
      position: relative;
      z-index: 2;
      margin-bottom: 60px;

      .info {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 10px;
        padding: 16px;
        width: 220px;
        cursor: pointer;
        z-index: 2;
        background: #F9F9F9;

        .title {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 4px;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .type {
          height: 20px;
          padding: 0 13px;
          border-radius: 100px;
          width: max-content;

          &.material {
            background: rgba(0, 136, 204, 0.1);
            color: #0088CC;
          }

          &.test {
            background: rgba(8, 181, 46, 0.1);
            color: #08B52E;
          }
        }
      }

      .actions {
        position: absolute;
        overflow: hidden;
        display: flex;
        width: 100%;
        border-radius: 0 0 10px 10px;
        top: 20px;
        z-index: -1;
        transition: all .3s;

        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding: 20px 0 10px 0;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;

          &.delete {
            background: #FCEFEF;
            color: #E26262;

            &:hover {
              background: #FFE2E2;
            }
          }

          &.change {
            background: #E6F3FA;
            color: #0088CC;

            &:hover {
              background: #D2EFFF;
            }
          }
        }
      }

      &.empty-block {
        font-weight: 500;
        padding: 20px 0 10px 0;
        background: #fff;
        font-size: 16px;
        text-align: center;

        span {
          color: #0088CC;
        }
      }

      &:hover {
        .actions {
          top: 65px;
        }
      }
    }

    & > .add-block {
      z-index: 2;
      cursor: pointer;
      transition: all .3s;

      .icon {
        fill: #0088CC;
      }

      &:hover {
        transform: scale(1.1);
      }
    }

    .line-vertical {
      position: absolute;
      top: 0;
      height: 100%;
      border: 1px dashed #e7e7e7;
      z-index: 1;
    }
  }
}

.modal-doctis.course-entity-create-modal {
  .modal-wrapper {
    max-height: 88vh;
    padding: 0;
    border-top-width: 0;
    border-bottom-width: 0;
  }

  .close {
    top: 18px;
    right: 18px;
  }
}
</style>
